import { isTouch } from 'util/index';
import * as cssVariable from 'cssVariables';
import { TILES_WITH_BACKGROUND_GUTTER } from '../Collection/Collection.const';
import { Styles } from 'jss';

const topGutterSM = isTouch ? cssVariable.gutter * 2 : cssVariable.gutter;

export default (theme: StyleTheme): Styles => ({
  relative: {
    position: 'relative',
  },
  link: {
    background: 'transparent',
    border: 'none',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    float: 'right',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  linkText: {
    fontSize: cssVariable.fontSizes.xsmall,
    fontWeight: cssVariable.fontWeights.bold,
    textTransform: 'uppercase',
  },
  button: {
    width: '100%',
    display: 'block',
    marginTop: cssVariable.gutter,
    height: 40,
    lineHeight: '38px',
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.navigation.border}`,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: theme.palette.navigation.background,
      borderColor: theme.palette.navigation.background,
      '& span': {
        color: theme.palette.navigation.colorActive,
      },
    },
    '&:focus': {
      border: `1px solid ${theme.palette.navigation.border}`,
    },
  },
  greenButton: {
    border: `solid 1px ${cssVariable.green500}`,
    borderRadius: '4px',
    '& $buttonText': {
      color: cssVariable.green500,
    },
  },
  buttonTilesWitGrayBackground: {
    '&:hover': {
      backgroundColor: cssVariable.grey300,
      borderColor: cssVariable.grey300,
    },
  },

  buttonTilesWithWhiteBackground: {
    backgroundColor: cssVariable.white,
    borderStyle: 'none',

    '& $buttonText': {
      color: cssVariable.grey600,
    },
  },
  buttonText: {
    width: '100%',
    display: 'block',
    color: cssVariable.grey500,
    fontSize: cssVariable.fontSizes.xsmall,
    fontWeight: cssVariable.fontWeights.bold,
    '&::first-letter': {
      textTransform: 'capitalize',
    },
  },
  cta: {
    position: 'absolute',
    display: 'block',
    top: 0,
    right: 0,
    borderRadius: 4,
    border: `1px solid ${cssVariable.green500}`,
    color: cssVariable.green500,
    backgroundColor: theme.palette.background,
    padding: '0 20px',
    height: 40,
    lineHeight: '38px',
    textAlign: 'center',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: cssVariable.green500,
      color: cssVariable.white,
      boxShadow: `0 1px 4px 0 ${cssVariable.transparentLightmode010}, 0 5px 10px 0 ${cssVariable.transparentLightmode010}`,
    },
    '&:active': {
      backgroundColor: cssVariable.green600,
    },
    // we gotta have this since there's the global focus style that removes border, dunno why
    '&:focus': {
      border: `1px solid ${cssVariable.green500}`,
    },
  },
  ctaTilesWithBackground: {
    top: TILES_WITH_BACKGROUND_GUTTER,
    right: TILES_WITH_BACKGROUND_GUTTER,
  },
  ctaText: {
    width: '100%',
    display: 'block',
    fontSize: cssVariable.fontSizes.xsmall,
    fontWeight: cssVariable.fontWeights.bold,
  },
  [theme.breakpoints.down('sm')]: {
    button: {
      marginTop: topGutterSM,
    },
    cta: {
      float: 'none',
      position: 'static',
      width: '100%',
      marginTop: topGutterSM,
    },
  },
});
